import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SidebarAdmin from './sidebaradmin';


import {
  Link
} from "react-router-dom";

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));



function ManageLocation () {
    React.useEffect(() => {
        if (document.body.classList.contains('adminbody_bg')) {
          document.body.classList.remove('body');
        }
        document.body.classList.add('adminbody_bg');
      }, []);


      const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };


  const top100Films = [
    { title: 'DR. M. CONTI SCHOOL' },
    { title: 'F R CONWELL MIDDLE SCH'},
    { title: 'HEIGHTS MIDDLE SCHOOL' },
    { title: 'M.L.KING JR. SCHOOL'},
    { title: 'M.L.KING JR. SCHOOL'},
   
  ];
  
  return (
    <Box sx={{ display: 'flex' }}>
    
    <SidebarAdmin />
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <DrawerHeader />
      <Typography paragraph>
            <div className='row'>
              <div className='col-md-12'>
                <div className='club-sec application-sec'>
                  <div className='container-fluid '>
                    <div className="admin-body-heading forms-heading-sec">
                      <h2>Manage Location</h2>
                      <Link to="/admin/addlocation"> <p className='stts-sec  go-frm-cols go-new-add mange-ur'>Add Location</p>

                        <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                        <div class="scroll-prompt-arrow-container new-go-spp">
                            <div class="scroll-prompt-arrow"><div></div></div>
                            <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                        </div>
                        </div>
                        </Link>
                    </div>
                    </div>
                 
                  </div>
                </div>
              </div>

              <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row margn-tp-mange-usr'>
                     
                      <div class="col-sm-3"  >
                        <div class="sorting-e-form sortmng" style={{ marginTop: '0px' }}>
                          <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">

                       
                          <p class="total-user right-user tot-app mng-app" style={{ marginTop: '0px' }}>Total Location 2</p>
                          


                      </div>

                      <div className='col-md-3'>
                      <div className='filtr-sec'>
                          
                           
                          <div className= "text-fld-sec appl_status_list adm-usr">
                            <input type="text"className='inpt-sec' placeholder='Location Name'/>   
                            <span className='search-sec'><SearchIcon /></span>
                          </div>
                        </div>
                        </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table class="table table-bordered">
                          <thead class="thead-light thead-travel thead-form">
                            <tr>

                              <th className='loc-width'>Location id</th>
                              <th className='std-id-width'>Location Name</th>
                              <th className='std-name-width'>Location No</th>
                           
                              <th className='stts-width'>Action</th>
                              {/* <th className='action-width'>Action</th> */}
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            <tr>
                                <td>386</td>
                                <td>LC #387</td>
                                <td>3</td>
                              
                          
                                <td>    <div className='stst-visi'>
                                            <span className='visib-sec'><EditIcon /></span></div></td>

                            </tr>

                          </tbody>
                        </table>
                      
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
         

                    
      </Typography>
     
    </Box>
  </Box>
);
}
export default ManageLocation;

